import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import VisorPDF from "@Utilitarios/VisorPDF/VisorPDF";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import * as _testing_ from "@Funciones/testing";
import "./MPedidoDetalle.css";

function MPedidoDetalle({
  origenComponente,
  registro = {},
  parametros,
  tipoEvento,
  fCerrarComponente,
  fEstablecerVariablesTabla,
  fActualizarTablaTotal,
}) {
  const { ecv_u, cv_u, rolUsuarioSesion, esComputadora } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);

  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });
  const [v_u, ev_u] = useState({
    //TABLA
    do_datosTabla: {},
    do_filtros: [],
    do_filtrosActualizados: {},
    da_grid: [],
    da_headgrid: [],
    d_multiselecion: false,
    do_seleccionados: {},

    d_editarPedido: false,
    d_editarEntrega: false,
    d_totalEntrega: registro?.totalEntrega,

    d_pagoEnYape: 0,
    d_pagoEnEfectivo: 0,
    d_tipoDistribucion: 0,
    d_pdf: "",
    d_esperandoProcesoTabla: false,

    da_gridRemate: [],
    da_headgridRemate: [],
    da_gridBonificacion: [],
    da_headgridBonificacion: [],
    d_verPdf: false,
    d_fecEntrega: _f_.fechaActual({
      formato: "yyyy-mm-dd",
    }),
    d_pedidoEntregado: "",
    d_comentarioPedido: parametros?.comentario,
    d_pdfPedido: "",
  });
  useEffect(() => {
    console.log("entre a pedido detalle");
    // fCerrarComponentePadre?.();
    console.log(origenComponente, registro, parametros, tipoEvento);
    let todo = registro?.entregado == "N" || v_u.d_editarPedido || v_u.d_editarEntrega ? "S" : "N";
    const detallePedidoAPI = _api_.f_detallePedido({
      parametros: {
        codPedido: registro?.codPedido ?? 0,
        todo,
        editarEntrega: v_u.d_editarEntrega,
        editarPedido: v_u.d_editarPedido,
      },
      timeout: 5000,
      origen: origenComponente,
    });
    detallePedidoAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          do_datosTabla: dPC.contenido,
          do_filtros: dPC.contenido.filtros,
          da_grid: dPC.contenido.grid,
          da_headgrid: dPC.contenido.headgrid,
          d_multiselecion: dPC.contenido.multiseleccion,
          d_tipoDistribucion: dPC.contenido.tipoDistribucion,
          d_pdfPedido: dPC.contenido.documento.pdf,
          d_pagoEnYape: dPC.contenido.pagoYape,
          d_pagoEnEfectivo: dPC.contenido.pagoEfectivo,
          d_pedidoEntregado: dPC.contenido.entregado,
        });
      }
    });
    const obtenerRematesAPI = _api_.f_estructuraRemate({
      parametros: {
        pedido: registro?.codPedido ?? 0,
        editarEntrega: v_u.d_editarEntrega,
      },
      timeout: 5000,
      origen: origenComponente,
    });
    obtenerRematesAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          da_gridRemate: dPC.contenido.grid,
          da_headgridRemate: dPC.contenido.headgrid,
        });
      }
    });
    const obtenerBonificacionAPI = _api_.f_estructuraBonificaciones({
      parametros: {
        pedido: registro?.codPedido ?? 0,
        editarEntrega: v_u.d_editarEntrega,
      },
      timeout: 5000,
      origen: origenComponente,
    });
    obtenerBonificacionAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          da_gridBonificacion: dPC.contenido.grid,
          da_headgridBonificacion: dPC.contenido.headgrid,
        });
      }
    });
  }, [recargaComponente]);

  useEffect(() => {
    console.log(v_u.do_filtrosActualizados);
  }, [v_u.do_filtrosActualizados]);
  return (
    <>
      {v_c.modal_mostrar && (
        <ModalInformacion
          titulo={v_c.modal_titulo}
          estilos={v_c.modal_estilos}
          fCerrar={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: false,
              preConfirmar_mostrar: false,
              procesandoAccion_mostrar: false,
              postConfirmar_mostrar: false,
            });
            _f_.asignar(ev_u, { d_verPdf: false });
          }}>
          {v_c.errores_mostrar && <_lul_.ListaUL texto={"Errores"} listaElementos={v_c.errores_lista} />}
          {v_u.d_verPdf && (
            <VisorPDF
              id="mi-pdf"
              titulo="PDF"
              base64={v_u.d_pdfPedido}
              nombreArchivo={`Comprobante_${registro?.codPedido ?? 0}_${_f_.fechaActual({ formato: "dd_mm_yyyy" })}_${_f_.horaActual({ formato: "hh_mm_ss" })}.pdf`}
              autoDownload={false}
              modoImpresion={esComputadora ? "sistema" : "ventana"}
            />
          )}
          {v_c.preConfirmar_mostrar && (
            <_preconf_.PreConfirmacion
              texto={`¿Seguro que desea finalizar la entrega del Pedido "${String(registro.codPedido).padStart(8, "0")}" con fecha ${_f_.formatearFecha({ valor: v_u.d_fecEntrega, formato: "dd/mm/yyyy" })}?`}
              fBotonAceptar={() => {
                _f_.asignar(ev_c, {
                  preConfirmar_mostrar: false,
                  procesandoAccion_mostrar: true,
                  modal_titulo: "⏳Finalizando Entrega",
                });
                const finalizarEntregaAPI = _api_.f_solicitarPedido({
                  parametros: {
                    codUsuario: registro?.usuarioSolicitante,
                    codPedido: registro?.codPedido,
                    comentario: v_u.d_comentarioPedido,
                    pedidooentrega: 2, //para finalizar entrega
                    tipo_comprobante: null,
                    tipo_documento: null,
                    numero_documento: null,
                    nombre_cliente: null,
                    montoEfectivo: 0,
                    montoYape: 0,
                    fechaEntregaEstimada: registro?.fechaEntregada,
                    fechaEntrega: v_u.d_fecEntrega,
                  },
                  timeout: 5000,
                });
                finalizarEntregaAPI.respuesta.then((dPC) => {
                  _f_.asignar(ecv_u, dPC, true, origenComponente);
                  console.log(dPC);
                  if (!dPC.error) {
                    _f_.asignar(ev_c, {
                      procesandoAccion_mostrar: false,
                      postConfirmar_mostrar: true,
                      modal_titulo: "Entrega Finalizada",
                    });
                    
                  } else {
                    _f_.asignar(ev_c, {
                      modal_mostrar: false,
                      preConfirmar_mostrar: false,
                      procesandoAccion_mostrar: false,
                      postConfirmar_mostrar: false,
                    });
                    _f_.asignar(ev_u, { d_verPdf: false });
                  }
                });
              }}
              fBotonCancelar={() => {
                _f_.asignar(ev_c, {
                  modal_mostrar: false,
                  preConfirmar_mostrar: false,
                  procesandoAccion_mostrar: false,
                  postConfirmar_mostrar: false,
                });
                _f_.asignar(ev_u, { d_verPdf: false });
              }}
            />
          )}
          {v_c.procesandoAccion_mostrar && <_procAcc_.ProcesandoAccion />}
          {v_c.postConfirmar_mostrar && (
            <_posconf_.PostConfirmacion
              fBotonDeAcuerdo={() => {
                _f_.asignar(ev_c, {
                  modal_mostrar: false,
                  preConfirmar_mostrar: false,
                  procesandoAccion_mostrar: false,
                  postConfirmar_mostrar: false,
                  modal_titulo: "",
                });
                _f_.asignar(ev_u, { d_verPdf: false });
                fCerrarComponente?.();
                fActualizarTablaTotal?.(true)
              }}
            />
          )}
        </ModalInformacion>
      )}
      <div className={"MPedidoDetalleCSS-contenedor"}>
        <div className={"titulo-componente"}>{`${registro?.nombreUsuarioSolicitante}`}</div>
        <div className={"MPedidoDetalleCSS-cabecera"}>
          <div className={"MPedidoDetalleCSS-c-fechas"}>
            {v_u.d_tipoDistribucion != 1 && (
              <_ipt_.Input4
                disabled
                tipo={"date"}
                texto={`Fecha Solicitada`}
                defaultValue={_f_.formatearFecha({
                  valor: registro?.fechaPedido,
                  formato: "yyyy-mm-dd",
                })}
              />
            )}
            {v_u.d_tipoDistribucion != 1 && (
              <_ipt_.Input4
                disabled
                tipo={"date"}
                texto={`Fec. Prog. Entrega`}
                defaultValue={_f_.formatearFecha({
                  valor: registro?.fechaEntregada,
                  formato: "yyyy-mm-dd",
                })}
              />
            )}
            <_ipt_.Input4
              disabled={["DIST01", "ADIST01"].includes(rolUsuarioSesion) || v_u.d_tipoDistribucion == 1}
              tipo={"date"}
              texto={`Fec. Entrega`}
              defaultValue={_f_.fechaActual({
                formato: "yyyy-mm-dd",
              })}
              onBlur={(evento) => {
                _f_.asignar(ev_u, { d_fecEntrega: evento.target.value });
              }}
            />
          </div>
          <div className={"MPedidoDetalleCSS-c-nroPedido"}>
            <_div_.Div2
              estilos={{ fuenteDiv2: "1.2rem" }}
              texto={`Nro. ${String(registro.codPedido).padStart(8, "0")}`}
            />
          </div>
        </div>
        <Filtros
          filtros={v_u.do_filtros}
          funcionObtenerValores={(valores) => {
            // console.log(valores);
            _f_.asignar(ev_u, { do_filtrosActualizados: valores });
          }}
        />
        <div className={"MPedidoDetalleCSS-tabla"}>
          <div>
            <_tabla_.Tabla
              origenComponente={origenComponente}
              modoVista={"modo2"}
              datosComplementarios={{ codPedido: registro?.codPedido }}
              cabecera={v_u.da_headgrid}
              registros={v_u.da_grid}
              filtros={v_u.do_filtrosActualizados}
              permiteMultiseleccion={v_u.d_multiselecion}
              permiteOpciones={true}
              camposCodigosSeleccion={["codigo"]}
              fObtenerSeleccionados={(seleccionados) => {
                _f_.asignar(ev_u, { do_seleccionados: seleccionados });
              }}
              // mapaDeComponentes={{
              //   MAgregarPersona,
              // }}
              fNotificarActualizacionDeTabla={(actualizar) => {
                if (actualizar) {
                  erecargaComponente((prev) => !prev);
                }
              }}
              fObtenerDatosParcialesActualizados={(datos) => {
                console.log(datos);
                _f_.asignar(ev_u, { d_totalEntrega: datos?.TotalEntrega });
              }}
              fObtenerEstadoProcesando={(estado) => {
                // console.log("esta procesando la tabla:",estado)
                _f_.asignar(ev_u, { d_esperandoProcesoTabla: estado });
              }}
            />
          </div>

          <div className={"MPedidoDetalleCSS-bonificacion-remate"}>
            <_tabla_.Tabla
              origenComponente={origenComponente}
              modoVista={"modo2"}
              datosComplementarios={{ codPedido: registro?.codPedido }}
              cabecera={v_u.da_headgridRemate}
              registros={v_u.da_gridRemate}
              filtros={v_u.do_filtrosActualizados}
              permiteMultiseleccion={v_u.d_multiselecion}
              permiteOpciones={true}
              camposCodigosSeleccion={["codProducto"]}
              fObtenerSeleccionados={(seleccionados) => {
                _f_.asignar(ev_u, { do_seleccionados: seleccionados });
              }}
              // mapaDeComponentes={{
              //   MAgregarPersona,
              // }}
              fNotificarActualizacionDeTabla={(actualizar) => {
                if (actualizar) {
                  erecargaComponente((prev) => !prev);
                }
              }}
              fObtenerDatosParcialesActualizados={(datos) => {
                console.log(datos);
                _f_.asignar(ev_u, { d_totalEntrega: datos?.TotalEntrega });
              }}
              fObtenerEstadoProcesando={(estado) => {
                // console.log("esta procesando la tabla:",estado)
                _f_.asignar(ev_u, { d_esperandoProcesoTabla: estado });
              }}
            />
            <_tabla_.Tabla
              origenComponente={origenComponente}
              modoVista={"modo2"}
              datosComplementarios={{ codPedido: registro?.codPedido }}
              cabecera={v_u.da_headgridBonificacion}
              registros={v_u.da_gridBonificacion}
              filtros={v_u.do_filtrosActualizados}
              permiteMultiseleccion={v_u.d_multiselecion}
              permiteOpciones={true}
              camposCodigosSeleccion={["codProducto"]}
              fObtenerSeleccionados={(seleccionados) => {
                _f_.asignar(ev_u, { do_seleccionados: seleccionados });
              }}
              // mapaDeComponentes={{
              //   MAgregarPersona,
              // }}
              fNotificarActualizacionDeTabla={(actualizar) => {
                if (actualizar) {
                  erecargaComponente((prev) => !prev);
                }
              }}
              fObtenerDatosParcialesActualizados={(datos) => {
                console.log(datos);
                _f_.asignar(ev_u, { d_totalEntrega: datos?.TotalEntrega });
              }}
              fObtenerEstadoProcesando={(estado) => {
                // console.log("esta procesando la tabla:",estado)
                _f_.asignar(ev_u, { d_esperandoProcesoTabla: estado });
              }}
            />
          </div>
        </div>
        <div className={"MPedidoDetalleCSS-comentario"}>
          <_txta_.TextArea
            
            onBlur={(evento) => {
              // console.log(evento.target.value)
              _f_.asignar(ev_u, { d_comentarioPedido: evento.target.value });
            }}
            texto="ingrese un comentario"
            defaultValue={v_u.d_comentarioPedido}
            estilos={{ anchoTA: "100%" }}
          />
        </div>

        <div className={"MPedidoDetalleCSS-opciones"}>
          <div className={"MPedidoDetalleCSS-pagos"}>
            {(!["DESP01"].includes(rolUsuarioSesion) || v_u.d_tipoDistribucion == 1) && (
              <>
                <_div_.Div2
                  estilos={{ fuenteDiv2: "1rem" }}
                  texto={`TOTAL: ${_f_.formatearValor({ valor: v_u.d_totalEntrega, tipo: "moneda", moneda: "PEN", precision: "2" })}`}
                />
                <_div_.Div2
                  estilos={{
                    fuenteDiv2: "1rem",
                    colorFondoDiv2: "#742582",
                    colorFuenteDiv2: "white",
                    fuenteDiv2: "0.8rem",
                    altoDiv2: "2rem",
                  }}
                  texto={`En Yape: ${_f_.formatearValor({ valor: v_u.d_pagoEnYape, tipo: "moneda", moneda: "PEN", precision: "2" })}`}
                />
                <_div_.Div2
                  estilos={{
                    fuenteDiv2: "1rem",
                    colorFondoDiv2: "#4db6ac",
                    colorFuenteDiv2: "black",
                    fuenteDiv2: "0.8rem",
                    altoDiv2: "2rem",
                  }}
                  texto={`En Efectivo: ${_f_.formatearValor({ valor: v_u.d_pagoEnEfectivo, tipo: "moneda", moneda: "PEN", precision: "2" })}`}
                />
              </>
            )}
          </div>

          {(v_u.d_editarEntrega || v_u.d_editarPedido) && (
            <_btn_.Boton
              disabled={v_u.d_esperandoProcesoTabla}
              texto="Finalizar Edición"
              tipo="btn-2"
              estilos={{ anchoB2: "8rem", color: "#dcad2f" }}
              onClick={() => {
                // const finalizarEntregaAPI = _api_.f_solicitarPedido({
                //   parametros: {
                //     codUsuario: registro?.usuarioSolicitante,
                //     codPedido: registro?.codPedido,
                //     comentario: v_u.d_comentarioPedido,
                //     pedidooentrega: 1, //para finalizar entrega
                //     tipo_comprobante: null,
                //     tipo_documento: null,
                //     numero_documento: null,
                //     nombre_cliente: null,
                //     montoEfectivo: 0,
                //     montoYape:0,
                //     fechaEntregaEstimada: registro?.fechaEntregada,
                //     fechaEntrega: null,
                //   },
                //   timeout: 5000,
                // });
                // finalizarEntregaAPI.respuesta.then((dPC)=>{
                //   _f_.asignar(ecv_u, dPC, true, origenComponente);
                //   console.log(dPC)
                //   if(!dPC.error){

                //   }
                // })
                erecargaComponente((prev) => !prev);
                _f_.asignar(ev_u, {
                  d_editarPedido: false,
                  d_editarEntrega: false,
                });
              }}
            />
          )}
          {!v_u.d_editarPedido && !v_u.d_editarEntrega && (
            <_btn_.Boton
              disabled={v_u.d_esperandoProcesoTabla}
              texto="PDF"
              tipo="btn-2"
              estilos={{ anchoB2: "3rem", color: "#af3232" }}
              onClick={() => {
                if (v_u.d_tipoDistribucion == 2) {
                  _f_.asignar(ev_u, { d_pdfPedido: "" });
                  const llamadoAPI = _api_.f_pdfDespachoPedido({
                    parametros: {
                      pedido: registro.codPedido,
                      cuenta: !["DESP01"].includes(rolUsuarioSesion) ? "S" : "N",
                      entregado: "S",
                    },
                    origen: origenComponente,
                    timeout: 5000,
                  });
                  llamadoAPI.respuesta.then((dPC) => {
                    _f_.asignar(ecv_u, dPC, true, origenComponente);
                    console.log(dPC.contenido);
                    if (!dPC.error) {
                      _f_.asignar(ev_u, { d_pdfPedido: dPC.contenido.reporte });
                    }
                  });
                  _f_.asignar(ev_c, { modal_mostrar: true, modal_titulo: "Detalle del Pedido" });
                  _f_.asignar(ev_u, { d_verPdf: true });
                } else {
                  _f_.asignar(ev_c, {
                    modal_mostrar: true,
                    modal_titulo: "Comprobante",
                    modal_estilos: { altoMI: "50rem", anchoMI: "30rem" },
                  });
                  _f_.asignar(ev_u, { d_verPdf: true });
                }
              }}
            />
          )}
          {!v_u.d_editarPedido && !v_u.d_editarEntrega && v_u.d_tipoDistribucion == 2 && (
            <_btn_.Boton
              disabled={v_u.d_esperandoProcesoTabla}
              texto="Editar Pedido"
              tipo="btn-2"
              estilos={{ anchoB2: "8rem", color: "#dcad2f" }}
              onClick={() => {
                erecargaComponente((prev) => !prev);
                _f_.asignar(ev_u, {
                  d_editarPedido: true,
                });
              }}
            />
          )}

          {!v_u.d_editarPedido &&
            !v_u.d_editarEntrega &&
            v_u.d_tipoDistribucion == 2 &&
            !["DIST01", "ADIST01"].includes(rolUsuarioSesion) &&
            v_u.d_pedidoEntregado == "N" && (
              <_btn_.Boton
                disabled={v_u.d_esperandoProcesoTabla}
                texto="Finalizar Entrega"
                tipo="btn-2"
                estilos={{ anchoB2: "8rem", color: "var(--color_verde_1)" }}
                onClick={() => {
                  if (v_u.d_fecEntrega == "") {
                    let errores = [];
                    errores.push("Se debe ingresar una fecha de entrega");
                    _f_.asignar(ev_c, { modal_mostrar: true, errores_mostrar: true, errores_lista: errores });
                  } else {
                    _f_.asignar(ev_c, {
                      errores_mostrar: false,
                      modal_mostrar: true,
                      modal_estilos: { anchoMI: "30rem", altoMI: "initial" },
                      modal_titulo: "Finalizar Entrega Confirmación",
                      preConfirmar_mostrar: true,
                    });
                  }

                  // erecargaComponente((prev) => !prev);
                  // _f_.asignar(ev_u, {
                  //   d_editarPedido: true,
                  // });
                }}
              />
            )}
          {!v_u.d_editarPedido &&
            !v_u.d_editarEntrega &&
            v_u.d_tipoDistribucion == 2 &&
            ["SADM01"].includes(rolUsuarioSesion) &&
            v_u.d_pedidoEntregado == "S" && (
              <_btn_.Boton
                texto="Editar Entrega"
                tipo="btn-2"
                estilos={{ anchoB2: "8rem", color: "var(--color_verde_1)" }}
                onClick={() => {
                  erecargaComponente((prev) => !prev);

                  _f_.asignar(ev_u, {
                    d_editarEntrega: true,
                  });
                }}
              />
            )}
        </div>
      </div>
    </>
  );
}
export default MPedidoDetalle;

/*

*/
